module.exports = __webpack_public_path__ + "img/TIME.aac3cc15.svg";